export default __webpack_public_path__ + "static/media/powergrid.48bd7154.webp";